import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _createSuper from '@babel/runtime/helpers/esm/createSuper';
import Cookies from 'js-cookie';
import { getUTMsParams } from '@landr/core';
import { Languages } from '@landr/core.models';
import { createRandomString } from '../../utils/utils.es.js';
import { SessionStorage } from '../../utils/storage.es.js';
import { AbstractPlatformProvider } from './AbstractPlatformProvider.es.js';

var LogOnBehalfCookiePrefix = 'logOnBehalf';
var APP_STATE_STORAGE_KEY_PREFIX = 'landr.auth.appState';
var BrowserPlatformProvider = /*#__PURE__*/function (_AbstractPlatformProv) {
  _inherits(BrowserPlatformProvider, _AbstractPlatformProv);
  var _super = _createSuper(BrowserPlatformProvider);
  function BrowserPlatformProvider(_ref) {
    var _this;
    var environment = _ref.environment,
      analytics = _ref.analytics,
      cookieSettings = _ref.cookieSettings;
    _classCallCheck(this, BrowserPlatformProvider);
    _this = _super.call(this);
    _this.environment = void 0;
    _this.analytics = void 0;
    _this.cookieSettings = void 0;
    _this.storage = void 0;
    _this.environment = environment;
    _this.analytics = analytics;
    _this.cookieSettings = cookieSettings;
    _this.storage = SessionStorage;
    return _this;
  }
  _createClass(BrowserPlatformProvider, [{
    key: "openUrl",
    value: function openUrl(url) {
      window.location.assign(url);
      return Promise.resolve();
    }
  }, {
    key: "getTargetUrl",
    value: function getTargetUrl() {
      return window.location.href;
    }
  }, {
    key: "getRootUrl",
    value: function getRootUrl() {
      return window.location.origin;
    }
  }, {
    key: "readStateAndCode",
    value: function readStateAndCode() {
      var _url$searchParams$get, _url$searchParams$get2;
      var url = new URL(window.location.href);
      var state = url.searchParams.get('state');
      var code = url.searchParams.get('code');
      var error = (_url$searchParams$get = url.searchParams.get('error')) !== null && _url$searchParams$get !== void 0 ? _url$searchParams$get : undefined;
      var errorDescription = (_url$searchParams$get2 = url.searchParams.get('error_description')) !== null && _url$searchParams$get2 !== void 0 ? _url$searchParams$get2 : undefined;
      return {
        state: state,
        code: code,
        error: error,
        errorDescription: errorDescription
      };
    }
  }, {
    key: "clearLogOnBehalfValue",
    value: function clearLogOnBehalfValue() {
      var logOnBehalfToken = this.getLogOnBehalfValue();
      if (logOnBehalfToken) {
        Cookies.remove(this.getLogOnBehalfCookieName(), {
          domain: this.cookieSettings.domain,
          secure: this.cookieSettings.secure
        });
      }
    }
  }, {
    key: "getLogOnBehalfValue",
    value: function getLogOnBehalfValue() {
      return Cookies.get(this.getLogOnBehalfCookieName()) || undefined;
    }
  }, {
    key: "getLogOnBehalfCookieName",
    value: function getLogOnBehalfCookieName() {
      return "".concat(LogOnBehalfCookiePrefix, "-").concat(this.environment);
    }
  }, {
    key: "resetAnalytics",
    value: function resetAnalytics() {
      return this.analytics.reset();
    }
  }, {
    key: "getDefaultHomePage",
    value: function getDefaultHomePage() {
      var urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('homePage') || undefined;
    }
  }, {
    key: "getDocumentReferrer",
    value: function getDocumentReferrer() {
      return window.document.referrer;
    }
  }, {
    key: "reload",
    value: function reload() {
      window.location.reload();
    }
  }, {
    key: "getLanguage",
    value: function getLanguage() {
      var urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('locale') || Languages.English;
    }
  }, {
    key: "onAppState",
    value: function onAppState(appState) {
      window.history.replaceState({}, document.title, appState.targetUrl);
    }
  }, {
    key: "addStoredAppStateIdToUrl",
    value: function addStoredAppStateIdToUrl(url, appStateId) {
      var newUrl = new URL(url);
      newUrl.searchParams.set('appStateId', appStateId);
      return newUrl.toString();
    }
  }, {
    key: "getStoredAppStateId",
    value: function getStoredAppStateId() {
      var urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('appStateId') || undefined;
    }
  }, {
    key: "loadStoredAppState",
    value: function loadStoredAppState(appStateId) {
      var storedAppState = this.storage.get(APP_STATE_STORAGE_KEY_PREFIX);
      if ((storedAppState === null || storedAppState === void 0 ? void 0 : storedAppState.appStateId) === appStateId) {
        this.storage.remove(APP_STATE_STORAGE_KEY_PREFIX);
        return storedAppState.appState;
      }
      return undefined;
    }
  }, {
    key: "storeAppState",
    value: function storeAppState(appState) {
      var appStateId = createRandomString();
      this.storage.save(APP_STATE_STORAGE_KEY_PREFIX, {
        appStateId: appStateId,
        appState: appState
      });
      return appStateId;
    }
  }, {
    key: "getUTMParams",
    value: function getUTMParams() {
      var UTMsParams = getUTMsParams(this.cookieSettings);
      return {
        source: UTMsParams.landr_utmSource,
        medium: UTMsParams.landr_utmMedium,
        campaign: UTMsParams.landr_utmCampaign,
        term: UTMsParams.landr_utmTerm,
        content: UTMsParams.landr_utmContent
      };
    }
  }, {
    key: "isServerSideRendering",
    value: function isServerSideRendering() {
      var _window$prerenderClou;
      return (_window$prerenderClou = window.prerenderCloudIsServerSideRendering) !== null && _window$prerenderClou !== void 0 ? _window$prerenderClou : false;
    }
  }]);
  return BrowserPlatformProvider;
}(AbstractPlatformProvider);

export { BrowserPlatformProvider };
